export default __webpack_public_path__ + "static/media/shuimo1.f5659d3e.png";